module.exports = __webpack_public_path__ + "img/game_wg.718cbff7.png";